import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map, switchMap } from 'rxjs/operators';

import { ToastService } from '../../../modules/shared/services/toast-message.service';
import { PentestService } from '../../../services/pentest/pentest.service';
import { PagedResponse } from '../general/models/general';
import { Pentest } from './models/Pentest';
import * as actions from './pentest.actions';

@Injectable()
export class pentestEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly service: PentestService,
    private toastService: ToastService,
  ) {}

  getPentestReports$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.getPentestReports),
      exhaustMap(({ pageNumber }) =>
        this.service
          .getPentestReports({
            pageNumber,
          })
          .pipe(
            map((pagedPentestReports: PagedResponse<Pentest>) => {
              return actions.getPentestReportsSuccess({ pagedPentestReports });
            }),
            catchError((error: any) =>
              of(actions.getPentestReportsFailure(error)),
            ),
          ),
      ),
    ),
  );

  getPentestReportById$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.getPentestReportById),
      exhaustMap((action) =>
        this.service.getPentestReportById(action.id).pipe(
          map((pentestReportById: Pentest) => {
            return actions.getPentestReportByIdSuccess({ pentestReportById });
          }),
          catchError((error: any) =>
            of(actions.getPentestReportByIdFailure(error)),
          ),
        ),
      ),
    ),
  );

  requestPentest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.requestPentest),
      exhaustMap((action) =>
        this.service.requestPentest(action.contactEmail, action.platforms).pipe(
          map(() => {
            this.toastService.success('Request pentest successful!');
            return actions.requestPentestSuccess();
          }),
          catchError((error: any) => of(actions.requestPentestFailure(error))),
        ),
      ),
    ),
  );

  offerResponse$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.offerResponse),
      exhaustMap((action) =>
        this.service.offerResponse(action.pentestId, action.newBody).pipe(
          switchMap(() =>
            this.service.getPentestReports({}).pipe(
              map((pagedPentestReports) =>
                actions.offerResponseSuccess({ pagedPentestReports }),
              ),
              catchError((error: any) =>
                of(actions.offerResponseFailure(error)),
              ),
            ),
          ),
        ),
      ),
    ),
  );
}
